import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';

export class TransitRequestDto {
    Id: string
    D_FWD: string
    D_AFT: string;
    AirDraught: string
    Anchors: string;
    ShipsCranes: string;
    Class: string
    BuildingDate: Date;
    LastName: string;
    LastFlagId: number;
    Extensions: string;
    FloatingUnits: string;
    IMONO: string
    MaxManouveringSpeed: string;
    RegisteryCertificateDate: Date;
    SecurityLevelId: number
    PropellerType: string;
    ActualTransitDate: Date;
    ArrivalDateTime: Date;
    Requirements: string;
    IsDeleted: boolean;
    IsArrived: boolean;
    IsCancelled: boolean;
    IsPendingDocument: boolean;
    DocuemntName: string;
    IsAgentPayedTotal: boolean;
    IsAgentPayedFirst: boolean;
    ExtraFee: string;
    HasMeasureExtraFee: boolean;
    MeasureExtraFee: string;
    ChequeNumber: string;
    IsConfirmedPayment: boolean;
    SecurityLevel: GenericLookup = new GenericLookup();
    Nationality: GenericLookup = new GenericLookup();
    RequestorId: string;
    FeesRequestId: string;
    IsFirstConfirmedPayment: boolean;
    IsTotalConfirmedPayment: boolean; 
    MeasurementDescription :string;
}
